const select = () => {
  const selectors = [
    {
      id: "#education-level",
      placeholder: "Текущий уровень вашего образования",
    },
    {
      id: "#Direction",
      placeholder: "Направление",
    },
    {
      id: "#Direction-modal",
      placeholder: "Направление",
    },
    {
      id: "#Education-modal",
      placeholder: "Текущий уровень вашего образования",
    },
    {
      id: "#Program",
      placeholder: "Программа обучения",
    },
    {
      id: "#Program",
      placeholder: "Программа обучения",
    },
    {
      id: "#category",
      placeholder: "Категория участника",
    },
    {
      id: "#Category-modal",
      placeholder: "Категория участника",
    },
    {
      id: "#shortFormProgram",
      placeholder: "Программа обучения",
    },
    {
      id: "#EmploymentFormat",
      placeholder: "Форма занятости",
    },
    {
      id: "#EmploymentFormat-modal",
      placeholder: "Форма занятости",
    },
    {
      id: "#shortCategory",
      placeholder: "Категория участника",
    },
    {
      id: "#City",
      placeholder: "Город",
    },
    {
      id: "#City-modal",
      placeholder: "Город",
    },
    {
      id: "#TrainingFormat",
      placeholder: "Формат обучения",
    },
    {
      id: "#TrainingFormat-modal",
      placeholder: "Формат обучения",
    },
    {
      id: "#shortTrainingFormat",
      placeholder: "Формат обучения",
    },
    {
      id: "#shortCity",
      placeholder: "Город",
    }
  ];

  selectors.forEach((item) => {
    let selector = $(item.id),
      message = "",
      placeholder;

    /* вывод сообщения в зависимости от поля */
    if (item.id == "#Program") {
      message = "Нет доступных программ";
    } else {
      message = "Ничего не найдено";
    }
    /* */

    /* замена placeholder по размеру экрана */
    if (item.id == "#education-level" || item.id == "#Education-modal") {
      if (window.innerWidth <= 767) {
        placeholder = "Образование";
      } else {
        placeholder = "Текущий уровень вашего образования";
      }
    } else {
      placeholder = item.placeholder;
    }
    /* */

    selector.select2({
      placeholder: placeholder,
      language: {
        noResults: function () {
          return message;
        },
      },
      escapeMarkup: function (markup) {
        return markup;
      },
    });

    selector.val(null).trigger("change");
  });
};

export default select;
